/* eslint-disable react/no-array-index-key */
import Img from '@components/img';
import type { ReactElement } from 'react';
import type { StackedImagesData } from 'types/components/stacked-images';
import type { DataProps } from 'types/props/data-props';
import { validateString } from 'utils/validate-string';

import styles from './stacked-images.module.scss';

const STARD_END_INDEX_OFFSET = 1;

const rootClass = validateString(styles.root);

function startEndToGridArea({
  start,
  end,
}: {
  start: number;
  end: number;
}): string {
  return `${start} / ${end + STARD_END_INDEX_OFFSET}`;
}

export default function StackedImagesComponent({
  images,
  priority = false,
  sizes,
}: Readonly<DataProps<StackedImagesData>>): ReactElement {
  return (
    <div className={rootClass}>
      {images.map((stackedImage, idx) => (
        <div
          key={`image-${idx}`}
          style={{
            gridColumn: startEndToGridArea(stackedImage.column),
            gridRow: startEndToGridArea(stackedImage.row),
            zIndex: images.length - idx,
            position: 'relative',
          }}
        >
          <Img
            alt=""
            // contain
            effect={stackedImage.imageEffect}
            imageSource={stackedImage.image}
            imageStyle={stackedImage.imageStyle}
            priority={priority}
            sizes={sizes}
          />
        </div>
      ))}
    </div>
  );
}
